module.exports = __webpack_public_path__ + "static/us-youth-soccer@2x-0fc546a00d538d30b9ffddc3c04a9172.png";